import router from "@/router";
import axios from "axios";

function initialUserState() {
  const user = JSON.parse(localStorage.getItem('isso-user'))
  return user || {
    employeeNo: '',
    name: '',
    userRights: '',
    roles: [],
    token: ''
  }
}

const state = {
  user: initialUserState()
};

const actions = {
  setUserInfo({ commit }, payload) {
    commit('setUser', payload)
    axios.defaults.headers.common["Authorization"] =
      "Bearer " + payload.token;

    localStorage.setItem('isso-user', JSON.stringify(payload))
    if (payload.token) {
      localStorage.setItem('isso-jwt', payload.token)
    }
  },
  logout({ commit }) {
    commit("cleanUser");
    localStorage.removeItem('isso-jwt')
    localStorage.removeItem('isso-user')
    // 需前往捷運局 EIP 入口頁面
    router.replace('/YWxscG93ZXI')


  },
};

const mutations = {
  setUser(state, payload) {
    state.user = payload
  },
  cleanUser(state) {
    state.user = initialUserState()
  }
};

const getters = {
  isAuthenticated: (state) => !!state.user.token,
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
